import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../components/Button'
import ForgotPasswordDialog from '../../components/ForgotPasswordDialog'
import Input from '../../components/Input'
import PageLayout from '../../components/PageLayout'
import { resetPasswordForEmail } from '../../helpers/supabase'
import { validateEmail } from '../../helpers/validations'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [emailFound, setEmailFound] = useState(true)
  const [hasGenericError, setHasGenericError] = useState(false)
  const [isRateLimited, setIsRateLimited] = useState(false)

  const { t } = useTranslation()

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    setHasGenericError(false)
    setIsRateLimited(false)

    const {
      error,
      isEmailNotFound,
      isRateLimited: rateLimited,
    } = await resetPasswordForEmail({ email })

    if (rateLimited) {
      setIsRateLimited(true)
      return
    }

    if (error && !isEmailNotFound) {
      setHasGenericError(true)
      return
    }

    setEmailFound(!isEmailNotFound)
    setIsDialogOpen(true)
  }

  return (
    <>
      <PageLayout>
        <div className="flex grow flex-col">
          <div className="shrink-0 space-y-6 text-center">
            <h1 className="custom-heading">
              {t('pages.account.forgotPassword.heading')}
            </h1>

            <p className="custom-subheading">
              {t('pages.account.forgotPassword.enterEmail')}
            </p>
          </div>

          <form
            className="flex grow flex-col justify-between"
            onSubmit={handleSubmit}
          >
            <div className="mt-6">
              <Input
                autoFocus
                placeholder={t('shared.email')}
                onChange={(event) => setEmail(event.target.value)}
                type="email"
                bgColor={'#FFFFFF'}
              />
              {isRateLimited && (
                <p className="mt-2 text-center text-sm text-red-500">
                  {t(
                    'pages.account.forgotPassword.rateLimited',
                    'Too many attempts. Please try again later.',
                  )}
                </p>
              )}
              {hasGenericError && (
                <p className="mt-2 text-center text-sm text-red-500">
                  {t('shared.error')}
                </p>
              )}
            </div>

            <Button
              disabled={!validateEmail(email)}
              title={t('pages.account.forgotPassword.resetPassword')}
              type="submit"
            />
          </form>
        </div>
      </PageLayout>

      {isDialogOpen && (
        <ForgotPasswordDialog
          open={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          emailFound={emailFound}
        />
      )}
    </>
  )
}
